// base64url without padding — the only string form bytes take on the wire.

export function b64uEncode(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
}

/** Throws on input that is not base64url. Use [b64uDecodeOrNull] for wire data. */
export function b64uDecode(text: string): Uint8Array {
  const base64 = text.replaceAll('-', '+').replaceAll('_', '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

/** Bytes off the network are allowed to be malformed — that is a `null`, not a throw. */
export function b64uDecodeOrNull(text: string): Uint8Array | null {
  try {
    return b64uDecode(text);
  } catch {
    return null;
  }
}
